/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_TitleInputs */

const vi_user_title = /** @type {(inputs: User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý người dùng`)
};

/**

* @param {User_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_title = /** @type {((inputs?: User_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_title(inputs)
});